export default {
    "type": "string",
    "enum": ["list","table","grid","gallery"],
    "default": "list"
}    